module.exports = __webpack_public_path__ + "won.mp3";